import { STORAGE_KEY, useAuthStore } from "../index";

export const registerStoreSynchronizer = () => {
  if (typeof window !== "undefined") {
    const syncStateFromStorage = () => {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed?.state) {
            useAuthStore.setState(parsed.state);
          }
        } catch (e) {
          console.warn("Failed to sync auth-store from localStorage", e);
        }
      }
    };

    window.addEventListener("storage", (event) => {
      if (event.key === STORAGE_KEY && event.newValue) {
        syncStateFromStorage();
      }
    });

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        syncStateFromStorage();
      }
    });
  }
};
